import { SearchParams } from '@/types/common'
import { UpdateLocation, UpdateSite } from '@/types/siteLocation'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const sitesDataConfig = {
  getByInterfaceId(searchParams: SearchParams = {}) {
    const url = `/api/sitelocation`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  updateSite(payload: UpdateSite) {
    const url = '/api/sitelocation/site'
    return axiosClient.put(url, payload)
  },
  updateLocation(payload: UpdateLocation) {
    const url = '/api/sitelocation/location'
    return axiosClient.put(url, payload)
  },
}

export default sitesDataConfig
